import { render, staticRenderFns } from "./navbar-page.vue?vue&type=template&id=dcb855fe&scoped=true"
import script from "./navbar-page.vue?vue&type=script&lang=js"
export * from "./navbar-page.vue?vue&type=script&lang=js"
import style0 from "./navbar-page.vue?vue&type=style&index=0&id=dcb855fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb855fe",
  null
  
)

export default component.exports